
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import Meta from '../../components/Meta/Meta'
import cross from '../../assets/images/icon/cross.svg'
import React, { useContext, useState, useEffect } from 'react'
import { DataContext } from '../../components/Context/Context'
import formatCurrency from '../../components/Util/Util';
import CompareEmpty from '../../components/CompareProduct/CompareEmpty/CompareEmpty'
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import "./CompareProduct.css"
const CompareProduct = () => {
    const value = useContext(DataContext);
    const [compare, setCompare] = value.compare;
    const removeCompareProduct = value.removeCompareProduct;
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [productIdtoDel, setProductIdtoDel] = useState('')

    const onOpenConfirmModal = (productId) => {
        console.log(productId)
        setProductIdtoDel(productId)
        setShowConfirmModal(true)
    }

    const deleteProduct = () => {
        console.log('delete product', productIdtoDel);
        removeCompareProduct(productIdtoDel)
        setProductIdtoDel('')
        setShowConfirmModal(false);
    }

    const cancelDeleteProduct = () => {
        console.log('cancel delete product')
        setProductIdtoDel('')
        setShowConfirmModal(false)
    }

    if (compare.length === 0) {
        return (
            <>
                <CompareEmpty />
            </>
        )
    }
    return (
        <>
            <ConfirmModal
                onConfirm={deleteProduct}
                onCancel={cancelDeleteProduct}
                show={showConfirmModal}
            />
            <div className="marginTop">
                <Meta title={' مقایسه محصولات'} />
                <BreadCrumb title="مقایسه محصولات " />
                <div className="compare-product-wrapper pb-5">
                    <div className="container-xxl">
                        <div className="row" >
                            {
                                compare.map(product => (
                                    <div className="col-12 col-sm-6 col-lg-3 p-3 p-lg-2 " key={product._id}>
                                        <div className="compare-product-card position-relative shadow-sec-bold">
                                            <img src={cross} alt="cross" className="position-absolute img-fluid cross" onClick={() => onOpenConfirmModal(product._id)} />
                                            <div className="product-card-image">
                                                <img className='img-fluid rounded' src={product.images[0]} alt="" />
                                            </div>
                                            <div className="compare-product-details pt-3">
                                                <div>
                                                    <div className="product-detail">
                                                        <h5> قیمت  :  </h5>
                                                        <p className='text-danger'> {formatCurrency(product.price)} </p>
                                                    </div>
                                                    <div className="product-detail">
                                                        <h5>برند : </h5>
                                                        <p>ایسوس</p>
                                                    </div>
                                                    <div className="product-detail">
                                                        <h5>نوع کالا : </h5>
                                                        <p>{product.name}</p>
                                                    </div>
                                                    <div className="product-detail">
                                                        <h5>مدل کالا : </h5>
                                                    </div>
                                                    <p className='d-fle'>{product.fullName}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompareProduct